import { mapObj } from '~/utils/objects/mapObj';

type EnvKey = 'BASE_URL' | 'MODE' | 'APP_VERSION' | 'APP_ENV' | 'API_URL';

const UNSAFE_CONFIG: Record<EnvKey, string> = {
  BASE_URL: import.meta.env.BASE_URL,
  MODE: import.meta.env.MODE,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  APP_ENV: import.meta.env.VITE_APP_ENV,
  API_URL: import.meta.env.VITE_API_URL,
};

export const Environments = mapObj(UNSAFE_CONFIG, (value) => {
  if (typeof value === 'string') {
    return value.length === 0 ? null : value;
  }

  return value;
});

export const IS_PROD_ENV = import.meta.env.MODE === 'production';
export const IS_STAGING_ENV = import.meta.env.MODE === 'staging';
export const IS_DEV_ENV = import.meta.env.MODE === 'development';

export const IS_LOCAL = import.meta.env.DEV;
